import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import DataTable, { MUIDataTableColumnDef, MUIDataTableOptions } from "mui-datatables";
import * as Dati from "src/Dati";
import { _TableLoader } from "..";

const useStyles = makeStyles(({ spacing }: Theme) => ({
    tableWrapper: {
        marginTop: spacing(4),
        position: "relative"
    }
}));

interface ISearchResultTableProps {
    Data: Dati.CRisAPIPagine<any> | undefined;
    Columns: MUIDataTableColumnDef[];
    Options: MUIDataTableOptions;
    IsLoading: boolean;
}

export const _SearchResultTable: React.FC<ISearchResultTableProps> = React.memo(({ Data, Columns, Options, IsLoading }) => {
    const classes = useStyles();

    return (
        <Box className={classes.tableWrapper}>
            {IsLoading && <_TableLoader />}
            <DataTable title="" data={Data?.Dati || []} columns={Columns} options={Options} />
        </Box>
    );
});



// WEBPACK FOOTER //
// ./src/inar2/components/common/SearchResultTable.tsx